import React from "react";

import {
  getStructuredMediaImage,
  type StructuredMediaImage
} from "../content/structuredMedia";
import type { DynamicBooksStructuredMediaAssetId } from "../../server/structuredMediaRegistry.js";

type StructuredMediaFigureProps = {
  assetId: DynamicBooksStructuredMediaAssetId;
  className?: string;
  loading?: "eager" | "lazy";
};

export function StructuredMediaFigure({
  assetId,
  className,
  loading = "lazy"
}: StructuredMediaFigureProps) {
  const media = getStructuredMediaImage(assetId);

  return (
    <figure
      className={["structured-media-figure", className].filter(Boolean).join(" ")}
      data-structured-media={media.assetId}
    >
      <StructuredMediaImg media={media} loading={loading} />
    </figure>
  );
}

export function StructuredMediaImg({
  media,
  loading = "lazy"
}: {
  media: StructuredMediaImage;
  loading?: "eager" | "lazy";
}) {
  return (
    <img
      src={media.src}
      alt={media.alt}
      width={media.width}
      height={media.height}
      loading={loading}
      decoding="async"
    />
  );
}
